import React from 'react'
import { Link } from 'react-router-dom'
import growth from '../images/growth.png'
import funded from '../images/funded.png'
import handshake from '../images/handshake.png'
import shortvideo from '../images/short-video.png'

export default function News() {
    return (
        <>
            <div className='newsletter news-sec'>
                <div className="container">
                    <div className="flex">
                        <div className="col">
                            <div className="post-slide">
                                <div className="post-img">
                                    <img src={growth} alt="byteedge" />
                                </div>
                                <div className="post-content">
                                    <h3 className="post-title">
                                        <Link to="https://hr.economictimes.indiatimes.com/news/industry/byteedge-emerges-from-stealth-mode-to-create-a-new-enterprise-ai-category-raises-1-5m/120849440?utm_source=copy&utm_medium=pshare" target='_blank'>byteEDGE emerges from stealth mode to create a new Enterprise AI category, raise $1.5M</Link>
                                    </h3>
                                    <div className='read-btn'>
                                        <Link to="https://hr.economictimes.indiatimes.com/news/industry/byteedge-emerges-from-stealth-mode-to-create-a-new-enterprise-ai-category-raises-1-5m/120849440?utm_source=copy&utm_medium=pshare" className="read-more" target='_blank'>read more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="post-slide">
                                <div className="post-img">
                                    <img src={funded} alt="byteedge" />
                                </div>
                                <div className="post-content">
                                    <h3 className="post-title">
                                        <Link to="https://m.economictimes.com/tech/funding/ai-knowledge-transfer-platform-byteedge-raises-1-5-million-in-round-led-by-trtl-ventures/amp_articleshow/120828028.cms" target='_blank'>AI knowledge transfer platform byteEDGE raises $1.5 million in round led by TRTL Ventures</Link>
                                    </h3>
                                    <div className='read-btn'>
                                        <Link to="https://m.economictimes.com/tech/funding/ai-knowledge-transfer-platform-byteedge-raises-1-5-million-in-round-led-by-trtl-ventures/amp_articleshow/120828028.cms" className="read-more" target='_blank'>read more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="post-slide">
                                <div className="post-img">
                                    <img src={handshake} alt="byteedge" />
                                </div>
                                <div className="post-content">
                                    <h3 className="post-title">
                                        <Link to="https://www.entrepreneur.com/en-in/news-and-trends/byteedge-raises-usd-15-mn-from-trtl-ventures-to-boost/491075" target='_blank'>byteEDGE raises USD 1.5 Mn from TRTL Ventures to Boost Enterprise AI knowledge transfer</Link>
                                    </h3>
                                    <div className='read-btn'>
                                        <Link to="https://www.entrepreneur.com/en-in/news-and-trends/byteedge-raises-usd-15-mn-from-trtl-ventures-to-boost/491075" className="read-more" target='_blank'>read more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="post-slide">
                                <div className="post-img">
                                    <img src={shortvideo} alt="byteedge" />
                                </div>
                                <div className="post-content">
                                    <h3 className="post-title">
                                        <Link to="https://indianstartupnews.com/funding/byteedge-which-converts-traditional-documents-into-multilingual-short-videos-raises-15-million-in-funding-9037650" target='_blank'>byteEDGE, which converts traditional documents into multilingual short videos, raises $1.5 million in funding</Link>
                                    </h3>
                                    <div className='read-btn'>
                                        <Link to="https://indianstartupnews.com/funding/byteedge-which-converts-traditional-documents-into-multilingual-short-videos-raises-15-million-in-funding-9037650" className="read-more" target='_blank'>read more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
